module.exports = __webpack_public_path__ + "img/bg-practical.08353e35.jpg";